// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for CreateTaskFromMessageStore, for use in the registry */ export const CreateTaskFromMessageStoreActionTypes = [
    ActionType.CreateEntitySucceededAction,
    ActionType.CreateEntityFailedAction,
    ActionType.UpdateTaskCreationStateAction
];
